<template>
  <v-container class="pa-8" :style="`max-width:800px;`">
    <v-row no-gutters>
      <v-col cols="12">
        <FunnelStep :color="stepsColors[0]" text="LEADS" :qtd="leads" width="100%" />
      </v-col>

      <v-container no-gutters class="pa-0 step-separator">
        <div class="d-flex justify-center">
          <FunnelStepSeparator :text="`${(taxaLeadsPorOportunidade * 100).toFixed(2)}%`" tooltip="Leads que viraram oportunidades"/>
        </div>
      </v-container>

      <v-col cols="12">
        <FunnelStep :color="stepsColors[1]" text="OPORTUNIDADES" :qtd="oportunidades" width="85%"  />
      </v-col>

      <v-container no-gutters class="pa-0 step-separator">
        <div class="d-flex justify-center">
          <FunnelStepSeparator :text="`${(taxaOportunidadesPorDemo * 100).toFixed(2)}%`" tooltip="Oportunidades que viraram demonstrações" />
        </div>
      </v-container>

      <v-col cols="12">
        <FunnelStep :color="stepsColors[2]" text="DEMONSTRAÇÕES" :qtd="demonstracoes" width="70%" />
      </v-col>

      <v-container no-gutters class="pa-0 step-separator">
        <div class="d-flex justify-center">
          <FunnelStepSeparator :text="`${(taxaDemosPorProposta * 100).toFixed(2)}%`" tooltip="Demonstrações que aceitaram uma proposta"/>
        </div>
      </v-container>

      <v-col cols="12">
        <FunnelStep :color="stepsColors[3]" text="PROPOSTAS" :qtd="propostas" width="55%" />
      </v-col>

      <v-container no-gutters class="pa-0 step-separator">
        <div class="d-flex justify-center">
          <FunnelStepSeparator :text="`${(taxaPropostasPorVenda * 100).toFixed(2)}%`" tooltip="Leads que aceitaram a proposta e se tornaram clientes"/>
        </div>
      </v-container>

      <v-col cols="12">
        <FunnelStep :color="stepsColors[4]" text="VENDAS" :qtd="vendas  " width="40%" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FunnelStep from './FunnelStep';
import FunnelStepSeparator from './FunnelStepSeparator';

export default {
  components: {
    FunnelStep,
    FunnelStepSeparator
  },
  props: {
    leads: Number | String,
    oportunidades: Number | String,
    demonstracoes: Number | String,
    propostas: Number | String,
    vendas: Number | String,
    taxaPropostasPorVenda: Number,
    taxaDemosPorProposta: Number,
    taxaLeadsPorOportunidade: Number | String,
    taxaOportunidadesPorDemo: Number,
  },
  data: function() {
    return {
      stepsColors: ['#3300cc', '#3961d0', '#4291bc', '#48c3a6', '#50f596']
    };
  }
};
</script>

<style scoped>
.step-separator {
  position: relative;
  top: -10px;
  margin-bottom: -20px;
}
</style>